<div class="empty-state">
  <mat-icon class="empty-state-icon">{{ icon }}</mat-icon>
  <h3 class="empty-state-title">{{ title }}</h3>
  <p class="empty-state-text">{{ text }}</p>
  <button *ngIf="buttonLabel" type="button" class="empty-state-btn" (click)="action.emit()">{{ buttonLabel }}</button>
</div>
